import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-virsa-android-16-interactive-flat-panels',
  templateUrl: './virsa-android-16-interactive-flat-panels.component.html',
  styleUrls: ['./virsa-android-16-interactive-flat-panels.component.scss']
})
export class VirsaAndroid16InteractiveFlatPanelsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('VIRSA Android 16 Interactive Flat Panels for Smart Classrooms');
    this.metaService.updateTag({ name: 'description', content: 'Discover VIRSA Android 16 Interactive Flat Panels with AI-powered teaching tools, DDR5 performance, multi-touch technology, and smart classroom integration for schools and universities.' });
    this.metaService.updateTag({ name: 'keywords', content: 'Android 16 interactive flat panels, smart classroom interactive panels, AI interactive flat panels, interactive flat panels for schools, VIRSA Android 16 IFP, smart classroom solutions India' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
